import { Gondor } from "../Gondor";

const ACTIONS = {
  CARD_BENEFIT: "/cardBenefit/",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.CARD_BENEFIT, { params });
}
